/// <reference path="../../typings/index.d.ts" />
/// <reference path="suxesiv.ts" />

$(document).ready(function () {
    let page = new Suxesiv.Main();
    page.setup();
});

